const setOnboardingUrl = LINK_ONBOARDING => ({ LINK_ONBOARDING });
const setAdvicesUrl = LINK_ADVICESPAGE => ({ LINK_ADVICESPAGE });
const setSearchUrl = LINK_SEARCHPAGE => ({ LINK_SEARCHPAGE });
const setJobOffersUrl = LINK_JOB_OFFERS => ({ LINK_JOB_OFFERS });
const setAddJobAlertUrl = LINK_ADD_JOB_ALERT => ({ LINK_ADD_JOB_ALERT });
const setJobAlertsUrl = LINK_JOB_ALERTS => ({ LINK_JOB_ALERTS });

module.exports = {
  ...setOnboardingUrl(process.env.LINK_ONBOARDING),
  ...setAdvicesUrl(process.env.LINK_ADVICESPAGE),
  ...setSearchUrl(process.env.LINK_SEARCHPAGE),
  ...setJobOffersUrl(process.env.LINK_JOB_OFFERS),
  ...setAddJobAlertUrl(process.env.LINK_ADD_JOB_ALERT),
  ...setJobAlertsUrl(process.env.LINK_JOB_ALERTS)
};
